module.exports = __webpack_public_path__ + "3e4ca3346fe18e30da53a6054bdad5cf.mp4";